export const toSpeakerSlug = (name) =>
  name
    .normalize('NFKD')
    .replace(/[’']/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

const scheduleAliases = {
  'arthur t oconnor': "Arthur O'Connor",
  'jodie bare': 'Jodie Bare-Thompson',
  'oubai hendi': 'Oubai Al Hendi',
  'prof eugene vinitsky': 'Eugene Vinitsky',
};

export const normalizeSpeakerName = (name) =>
  name
    .trim()
    .toLowerCase()
    .replace(/[.’']/g, '')
    .replace(/\s+/g, ' ');

export const resolveScheduleSpeaker = (displayName, speakerLookup) => {
  const normalized = normalizeSpeakerName(displayName);
  const aliasedName = scheduleAliases[normalized];
  const canonicalName = aliasedName
    ? speakerLookup[normalizeSpeakerName(aliasedName)]
    : speakerLookup[normalized];

  return canonicalName || null;
};
